module.exports = __webpack_public_path__ + "static/media/arrow-bttn.cf388060.svg";